module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/categories/spleen-a9ffa5dc02c8b13e341ebb61bc0f43b0.png";